export const en = {
    'add-payer': 'add a payer',
    'no-payers':
        "You can't set up a deactivation threshold as no payer is specified for your account. You can {addPayerLink} and set up the deactivation threshold",
    'no-payment-methods':
        'You cannot set the deactivation threshold as ads payment is not available for all payers associated with your account. To solve the problem, {writeToUsLink}.',
    'try-later': 'Something went wrong. Please try again.',
    'write-to-us': 'write to us'
};
